import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { ConfirmationService } from '@openng/optimus-ui/api';
import { environment } from '../envs/environment';
import { Auth } from '../services/auth';
import { SILENT_REQUEST } from '../data/http-context';

let sessionExpiredDialogOpen = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) return next(req);

  if (environment.skipAuth) {
    return next(req.clone({ setHeaders: { 'x-api-key': environment.apiKey } }));
  }

  const auth = inject(Auth);
  const confirmationService = inject(ConfirmationService);

  return from(auth.getAccessToken()).pipe(
    switchMap(token => {
      const headers: Record<string, string> = { 'x-api-key': environment.apiKey };
      if (token) headers['authorization'] = `Bearer ${token}`;
      return next(req.clone({ setHeaders: headers }));
    }),
    catchError(err => {
      if (
        err.status === HttpStatusCode.Unauthorized &&
        !sessionExpiredDialogOpen &&
        !req.context.get(SILENT_REQUEST)
      ) {
        sessionExpiredDialogOpen = true;
        confirmationService.confirm({
          header: 'Session Expired',
          message: 'Your session has expired. Please log in again to continue.',
          acceptLabel: 'Login',
          rejectVisible: false,
          accept: () => {
            sessionExpiredDialogOpen = false;
            auth.clear().then(() => auth.login(window.location.pathname));
          },
          reject: () => {
            sessionExpiredDialogOpen = false;
          },
        });
      }
      return throwError(() => err);
    })
  );
};
